//import react from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@ds/ds-snam/react";
import { AppUserRole, BadgeStatus, EntityType, UICommand } from "shared/constants";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";


interface IProps{
    currentStatus:number,
    entityType:EntityType,
    onClick:(command:UICommand)=>void
}
const ApproveButtons: React.FC<IProps> = (props): JSX.Element => {
    const {t} = useTranslation(['contract', 'app']);
    const {currentStatus, entityType, onClick} = props;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    
    const getTranslationPath = ()=>{
        let retVal:string = "";
        switch(entityType){
            case EntityType.DRIVER:
                retVal = 'drivers.driverData';
                break;
            case EntityType.VEHICLE:
                retVal = 'vehicle.vehicleData';
                break;
            default:
                retVal = "";
                break;
        }
        return retVal;
    }

    const renderButtons = ( buttons: { labelKey: string, command: UICommand, variant: 'primary' | 'secondary', ariaLabel: string }[]) => {
        return buttons.map(({ labelKey, command, variant, ariaLabel }) => (
            <Button
                key={command}
                buttonType="button"
                buttonUIVariant={variant}
                buttonSize="medium"
                buttonLabel={t(labelKey, { ns: 'app', what: ""  })}
                buttonIcon=""
                isDisabled={false}
                buttonAriaLabel={ariaLabel}
                onClick={() => onClick(command)}
            />
        ));
    }

    return (
        <>
            <div style={{display: "flex", gap: "16px"}}>
                {currentStatus === BadgeStatus.TOAPPROVE &&<>{
                    renderButtons([
                        { labelKey: 'general.buttons.reject', command: UICommand.REJECT, variant: 'secondary', ariaLabel: 'deny button' },
                        { labelKey: 'general.buttons.approve', command: UICommand.APPROVE, variant: 'primary', ariaLabel: 'credit button' },
                    ])}</>
                }

                {(currentStatus === BadgeStatus.TO_CREDIT && entityType!==EntityType.VEHICLE) && <>{
                    renderButtons([
                        { labelKey: 'general.buttons.refuseElement', command: UICommand.REJECT_CREDIT, variant: 'secondary', ariaLabel: 'deny button' },
                        { labelKey: 'general.buttons.creditElement', command: UICommand.CREDIT, variant: 'primary', ariaLabel: 'credit button' },
                    ])}</>
                }


                {(currentStatus === BadgeStatus.TO_CREDIT && entityType===EntityType.VEHICLE) &&
                    <>
                        {(appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE || appUserRole===AppUserRole.TL_MANAGER) &&<>
                            {renderButtons([
                                { labelKey: 'general.buttons.refuseElement', command: UICommand.REJECT_CREDIT, variant: 'secondary', ariaLabel: 'deny button' },
                                { labelKey: 'general.buttons.creditElement', command: UICommand.CREDIT_SALES, variant: 'primary', ariaLabel: 'credit button' },
                            ])}</>
                        }
                    </>
                }
                {(currentStatus === BadgeStatus.ACCREDITED_SALES && entityType===EntityType.VEHICLE) && 
                    <>
                        {(appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.TL_MANAGER) &&<>
                           {/* renderButtons([
                                { labelKey: 'general.buttons.refuseElement', command: UICommand.REJECT_CREDIT, variant: 'secondary', ariaLabel: 'deny button' },
                                { labelKey: 'general.buttons.creditElement', command: UICommand.CREDIT, variant: 'primary', ariaLabel: 'credit button' },
                            ])*/}</>
                        }
                    </>
                }
                
            </div>
        </>
    );
}

export default ApproveButtons;